import React, { Component } from 'react';
import * as yup from 'yup';
import { message } from 'antd';
import { Layout } from '../../../Common/Component';
import eye from '../../../../Assets/images/eye.svg';
import eyeoff from '../../../../Assets/images/eye-off.svg';
import {errorHandle} from "../../../Common/errorHandle";
class ResetPassword extends Component {
  state = {
    new_password1: "",
    new_password2: "",
    uid: "",
    token: "",
    validPassword: {
      containsUppercase: false,
      containsNumber: false,
      checkLength: false,
    },
    is_btn_active: false,
    new_password_eye1: false,
    new_password_eye2: false,
    loader: false
  }


  // Password Change
  onPasswordChange = (e) => {
    let { validPassword } = this.state;
    if (e.target.name === 'new_password1') {
      validPassword = Object.assign(validPassword, {
        'containsUppercase': (/[A-Z]/).test(e.target.value),
        'containsNumber': (/\d/).test(e.target.value),
        'checkLength': e.target.value.length >= 8,
      });

    }

    this.setState({ [e.target.name]: e.target.value, validPassword }, () => {
      this.validateUser();
    });

  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (Object.keys(props.resetPWD.data).length > 0 && props.resetPWD.data !== this.props.resetPWD.data) {

      message.success('Password Change successfully');
      this.setState({
        new_password1: "",
        new_password2: "",
        is_btn_active: false,
        loader: true
      })
      setTimeout(() => {
        this.props.history.push('/login')
      }, 1500);

      // window.location.assign('/login')
    }
    if (Object.keys(props.resetPWD.errors).length > 0 && props.resetPWD.errors !== this.props.resetPWD.errors) {
      // Display error message 
      if (props.resetPWD.errors.token) {
        message.error(`TOKEN:${props.resetPWD.errors.token}`)
      }
      else if (props.resetPWD.errors.uid) {
        message.error(`UID:${props.resetPWD.errors.uid}`)
      }

      else if (props.resetPWD.errors.new_password2) {
        message.error(props.resetPWD.errors.new_password2)
      }
      else {
        errorHandle(props?.resetPWD?.errors)
      }
      this.setState({
        loader: false
      })

    }

  }

  componentDidMount = () => {
    let user = JSON.parse(localStorage.getItem('userKey'))
    if (user && Object.keys(user).length > 0) {
      window.location.assign('/account');
    }
  }

  // Validate Form
  validateUser = () => {
    var self = this;
    setTimeout(() => {
      let { new_password1, new_password2, validPassword } = this.state;
      const UserSchema = yup.object().shape({
        new_password1: yup.string().required("Password is required"),
        new_password2: yup.string()
          .oneOf([yup.ref('new_password1'), null], 'Passwords must match'),
        validPassword: yup.object().shape({
          containsUppercase: yup.bool().oneOf([true], 'containsUppercase'),
          containsNumber: yup.bool().oneOf([true], 'containsNumber'),
          checkLength: yup.bool().oneOf([true], 'checkLength'),
        })
      })

      const UserData = {
        new_password1,
        new_password2,
        validPassword
      }
      // check validity
      let IsValid;

      UserSchema.isValid(UserData)
        .then(function (valid) {
          IsValid = valid
        });

      setTimeout(() => {
        if (IsValid) {
          self.setState({
            errors: {}
          })


          self.setState({
            is_btn_active: true
          })
        }
        else {
          UserSchema.validate(UserData, { abortEarly: false })
            .catch(function () {
              self.setState({
                is_btn_active: false
              })
            });
        }
      }, 100);
    }, 300);
  }

  //Update PAssword
  UpdatePassword = (e) => {
    let { new_password1, new_password2, } = this.state;
    let uid = '';
    e.preventDefault();
    if (this.props.location.search.split('=')[1]) {
      uid = this.props.location.search.split('=')[1]
    }
    // console.log(this.props.location.search.split('=')[1])
    let data = {
      "new_password1": new_password1,
      "new_password2": new_password2,
      "token": this.props.match.params.token,
      "uid": uid,
    }

    this.setState({
      loader: true
    })

    this.props.newPassword(data);
  }


  render() {
    let { new_password1, new_password2, is_btn_active, new_password_eye1, new_password_eye2, validPassword, loader } = this.state;

    return (
      <Layout>
        <div className="page_inner_content">
          <div className="truck-image-wrapper">
            <img className="truck-image no-mobile" src="https://doody-fe-bucket.s3.amazonaws.com/truck.png" alt="truck" />
            <img className="mobile-nav" src="https://doody-fe-bucket.s3.amazonaws.com/truck-responsive.png" alt="truck" />
          </div>
          <div className="container">
            <div className="auth-container login-container">
              <div className="row">
                <div className="col-lg-6 col-md-7 col-xl-5 block-form">
                  <div className="top-padding">
                    <h2>Set your new password</h2>
                    <h5>Choose and confirm your new password.</h5>

                    <form onSubmit={(e) => { this.UpdatePassword(e) }}>
                      <div className="form-group ico-position">
                        <input
                          type={new_password_eye1 ? "text" : "password"}
                          name="new_password1"
                          value={new_password1}
                          onChange={(e) => { this.onPasswordChange(e) }}
                          className="form--control"
                          placeholder="Choose Password"
                        />
                        <span className="eye-icon">
                          <img src={new_password_eye1 ? eye : eyeoff} alt="" onClick={() => {
                            this.setState({ new_password_eye1: !this.state.new_password_eye1 })
                          }} />
                        </span>
                      </div>
                      <div className="guidelines top-margin">
                        <div className={validPassword.checkLength ? 'box password_box_susscess' : 'box'}></div>
                      Passwords must be 8 or more characters in length
                      </div>
                      <div className="guidelines">
                        <div className={validPassword.containsUppercase ? 'box password_box_susscess' : 'box'} ></div>
                      Passwords must contain 1 or more uppercase characters
                      </div>
                      <div className="guidelines">
                        <div className={validPassword.containsNumber ? 'box password_box_susscess' : 'box'} ></div>
                      Passwords must contain 1 or more numbers
                      </div>
                      <div className="form-group mt-20 ico-position">

                        <input
                          type={new_password_eye2 ? "text" : "password"}
                          name="new_password2"
                          value={new_password2}
                          onChange={(e) => { this.onPasswordChange(e) }}
                          className="form--control"
                          placeholder="Confirm Password"
                        />
                        <span className="eye-icon">
                          <img src={new_password_eye2 ? eye : eyeoff} alt="" onClick={() => {
                            this.setState({ new_password_eye2: !this.state.new_password_eye2 })
                          }} />
                        </span>

                      </div>
                      <div className="btn-grp">
                        <button type="submit"
                          disabled={!is_btn_active}
                          className="btn lg-btn btn--secondary w-100">Confirm new password</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        {loader && <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>}
      </Layout>

    );
  }
}

export default ResetPassword;